import { h, Fragment } from "preact";
import { useContext } from "preact/hooks";
import { ViralReferralWidgetContext } from "../index";

const OfferTerms = props => {
  const viralReferralWidgetContext = useContext(ViralReferralWidgetContext);
  const offerTerms =
    viralReferralWidgetContext.viewStateHistory.currentView.params;

  return (
    <Fragment>
      <div className="grow  p-4 overflow-y-auto">
        <h1
          id="corner-referral-hero-text"
          className=" fonnt-bold text-xl text-center px-2 pb-2"
        >
          {viralReferralWidgetContext.currentLanguage &&
          viralReferralWidgetContext.currentLanguage.offer_terms
            ? viralReferralWidgetContext.currentLanguage.offer_terms
            : "Offer Terms"}
        </h1>
        <div id="corner-offer-terms-view" className="coca-offer-terms-view p-2">
          <span dangerouslySetInnerHTML={{ __html: offerTerms }} />
        </div>
      </div>
      <div
        id="corner-referral-initial-cta"
        className="coca-referral-initial-cta p-2 grow-0 flex flex-col items-stretch"
      >
        <a
          onClick={() => {
            viralReferralWidgetContext.viewStateHistory.goBack();
          }}
          target="_blank"
          id="corner-cowi-big-button-offer-terms"
          className="coca-cowi-big-button rounded-md text-center cursor-pointer text-base font-bold mb-1 p-2 grow text-center"
          ref={node => {
            if (node)
              node.style.setProperty("background", `#464646`, "important");
          }}
        >
          <span
            ref={node => {
              if (node) node.style.setProperty("color", `white`, "important");
            }}
          >
            {" "}
            {viralReferralWidgetContext.currentLanguage &&
            viralReferralWidgetContext.currentLanguage.go_back_button
              ? viralReferralWidgetContext.currentLanguage.go_back_button
              : "Go Back"}
          </span>
        </a>
      </div>
    </Fragment>
  );
};

export default OfferTerms;
